import imageCompression from 'browser-image-compression';

export async function compressImage(file: File): Promise<File> {
  // Only compress if file is larger than 1MB
  if (file.size <= 1024 * 1024) {
    return file;
  }

  const options = {
    maxSizeMB: 1,
    maxWidthOrHeight: 1920, // Maintain good quality for modern displays
    useWebWorker: true,
    fileType: file.type,
  };

  try {
    return await imageCompression(file, options);
  } catch (error) {
    console.error('Error compressing image:', error);
    throw error;
  }
}

export async function compressMedia(file: File): Promise<File> {
  try {
    if (file.type.startsWith('image/')) {
      return await compressImage(file);
    }
    return file; // Return video files as-is
  } catch (error: any) {
    console.error('Media processing error:', error);
    throw error;
  }
}